"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjustModalLabel = exports.assembleModalLabel = exports.countMessagesWithAttachment = exports.messagePartToContent = exports.createMessageWithAttachment = exports.preRenderImage = exports.readURL = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const types_1 = require("./types");
const styled_components_1 = __importDefault(require("styled-components"));
const react_1 = require("react");
const readURL = (file) => {
    return new Promise((res, rej) => {
        const reader = new FileReader();
        reader.onload = (e) => { var _a; return res((_a = e.target) === null || _a === void 0 ? void 0 : _a.result); };
        reader.onerror = (e) => rej(e);
        reader.readAsDataURL(file);
    });
};
exports.readURL = readURL;
const preRenderImage = (src) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
    });
};
exports.preRenderImage = preRenderImage;
const createMessageWithAttachment = async (url, img, label, text, author, attachment) => {
    const { naturalWidth, naturalHeight } = img;
    const defaultAttachmentSize = {
        url,
        size: {
            width: naturalWidth,
            height: naturalHeight
        },
        authRequired: false
    };
    const defaultAttachment = {
        mediaId: "",
        sizes: {
            large: defaultAttachmentSize,
            medium: defaultAttachmentSize,
            thumbnail: defaultAttachmentSize
        }
    };
    return {
        messageParts: [{ text, name: types_1.MessagePartType.TEXT }],
        align: "right",
        id: "",
        label,
        timestamp: Date.now(),
        attachment: attachment ? attachment : defaultAttachment,
        isError: !attachment,
        author
    };
};
exports.createMessageWithAttachment = createMessageWithAttachment;
const richPartToElement = (part, textElements) => {
    const textConfig = {
        bold: false,
        italic: false,
        color: null
    };
    part.methods.forEach((method) => {
        if ("type" in method &&
            method.type ===
                types_1.RichPartMethodType.TYPOGRAPHICAL_EMPHASIS) {
            const typographicalEmphasis = method;
            if (typographicalEmphasis.subType === types_1.TypographicalEmphasis.BOLD) {
                textConfig.bold = true;
                return;
            }
            if (typographicalEmphasis.subType === types_1.TypographicalEmphasis.ITALIC) {
                textConfig.italic = true;
                return;
            }
        }
        if ("colorType" in method) {
            const { colorType } = method;
            textConfig.color = colorType;
            return;
        }
    });
    textElements.push((0, jsx_runtime_1.jsx)(RichText, { bold: textConfig.bold, italic: textConfig.italic, textColor: textConfig.color, children: part.text }, part.text));
};
const RichText = styled_components_1.default.span `
  display: inline;

  ${({ textColor, theme }) => `color: ${textColor === types_1.ForegroundColorType.WARN
    ? theme.colors.yellowBase
    : "inherit"}`};
  ${({ bold }) => (bold ? `font-weight: 600` : "")};
  ${({ italic }) => (italic ? `font-style: italic` : "")};
`;
const messagePartToContent = (messageParts) => {
    const content = [];
    if (!messageParts)
        return content;
    messageParts.forEach((part) => {
        switch (part.name) {
            case types_1.MessagePartType.TEXT:
                return content.push((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: part.text }, part.text));
            case types_1.MessagePartType.DATE:
                return content.push((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: part.isoDate }, part.isoDate));
            case types_1.MessagePartType.LINK:
                return content.push((0, jsx_runtime_1.jsx)("a", { href: part.url, children: part.label }, part.label));
            case types_1.MessagePartType.RICH_TEXT:
                return richPartToElement(part, content);
        }
    });
    return content;
};
exports.messagePartToContent = messagePartToContent;
const countMessagesWithAttachment = (messages) => {
    let messagesWithAttachment = 0;
    messages.forEach((msg) => {
        if (msg.attachment) {
            messagesWithAttachment++;
        }
    });
    return messagesWithAttachment;
};
exports.countMessagesWithAttachment = countMessagesWithAttachment;
const adjustModalLabel = (label) => label.replace(",", "").split("|")[0];
exports.adjustModalLabel = adjustModalLabel;
const assembleModalLabel = (isAuthor, t, authorName, label) => {
    return `${t(`chat.modal.${isAuthor ? "receivedFrom" : "sendBy"}`)} ${authorName} ${t("chat.modal.on")} ${adjustModalLabel(label)}`;
};
exports.assembleModalLabel = assembleModalLabel;
//# sourceMappingURL=utils.js.map